import styled from '@emotion/styled';

export const MainWrapperDiv = styled('div')`
  height: inherit;
  padding: 10px;
`;

export const MainInfoDiv = styled('div')`
  width: 100%;
`;

export const HeadingDiv = styled('div')`
  width: 100%;
`;

export const InfoDetailDiv = styled('div')`
  padding: 15px;
  /* background-color: lightgrey; */
`;
export const LegacyAppDiv = styled('div')`
  width: 20%;
  // margin-left: 1rem;
  // margin-bottom: 1rem;
`;
